import { z } from "zod";

/**
 * Validation schema for quote submissions (Calculator & Offer Modal)
 */
export const quoteSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email("Please enter a valid email address")
    .max(255, "Email must be less than 255 characters"),
  fullName: z
    .string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be less than 100 characters")
    .optional(),
  company: z
    .string()
    .trim()
    .max(100, "Company name must be less than 100 characters")
    .optional(),
  projectGoal: z
    .string()
    .trim()
    .min(10, "Please provide more details about your project")
    .max(1000, "Project description must be less than 1000 characters")
    .optional(),
});

/**
 * Validation schema for challenge/idea submissions
 */
export const challengeSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email("Please enter a valid email address")
    .max(255, "Email must be less than 255 characters"),
  idea: z
    .string()
    .trim()
    .min(20, "Please provide more details about your idea (at least 20 characters)")
    .max(2000, "Idea description must be less than 2000 characters"),
});

/**
 * Simple email validation for newsletter signups
 */
export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email("Please enter a valid email address")
  .max(255, "Email must be less than 255 characters");
